module.exports = __webpack_public_path__ + "zilky-v-obliceji_1_before.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/dermatologie/zilky-v-obliceji_1_before.jpg
// module id = 994
// module chunks = 0